import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedProducts, selectUrlsForShare } from '../../../selectors/selected';
import { selectCianHost } from '../../../selectors/config';
import { ShareWhatsAppButton } from '../../../components/MassActions';
import { trackShareWhatsAppClick } from './tracking';

export const ShareWhatsAppButtonContainer = () => {
  const cianHost = useSelector(selectCianHost);
  const urls = useSelector(selectUrlsForShare(cianHost));
  const selectedProducts = useSelector(selectSelectedProducts);

  const handleClick = () => {
    trackShareWhatsAppClick(selectedProducts);
  };

  return <ShareWhatsAppButton urls={urls} onClick={handleClick} />;
};
